<template>
  <div class="container">
    <AudioIcon />
    <div class="text-container">
      <p>{{ text }}</p>
      <div class="button" @click="onForward">{{ buttonText }}</div>
    </div>
  </div>
</template>

<script>
import { tLevel2 } from '@game/utils';
import { audioMixinLevel1 } from '@game/mixins/audioMixin.js';

export default {
  name: 'Scene2',
  mixins: [audioMixinLevel1],
  data() {
    return {
      text: tLevel2('scene8.text'),
      buttonText: tLevel2('scene8.buttonText'),
    }
  },
  methods: {
    onBackward() {
      this.$audioManager.playButtonPrevious(() => {
        this.$router.go(-1)
      })
    },
    onForward() {
      this.$audioManager.playButtonNext(() => {
        this.$router.push({ name: 'L2Scene9' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
    background-image: url(@game/Level02/assets/img/shylock-2.jpg);

    .text-container {
        min-height: 15%;
        .button {
          position: absolute;
          bottom: -5px;
          right: 0;

          &:hover {
            opacity: .8;
          }
        }
    }
}

</style>